/**
 * Parses the date in format DD.MM.yyyy into a Date object
 * @param input the desired date string to parse
 * @returns the date object
 */
export function parseDate(input: string): Date {
    const [day, month, year] = input.split('.').map(Number);
    return new Date(year, month - 1, day);
}